import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './http-interceptor/jwt-interceptor';
import { ErrorInterceptor } from './http-interceptor/error-interceptor';
import { CachingInterceptor } from './http-interceptor/caching-interceptor';
import { DecryptInterceptor } from './http-interceptor/decrypt-interceptor';

export const httpInterceptorProviders = [
    // {
    //     provide: HTTP_INTERCEPTORS, useClass: DecryptInterceptor, multi: true
    // },
    {
        provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    
]; 